import { post, put, destroy } from './index';

export const postCustomField = async (modelForm) => {
  return post('/api/v1/custom_fields/', {
    model_form: modelForm,
  });
};

export const putCustomField = async (modelFormId, orgId, customField) => {
  return put(`/api/v1/custom_fields/${modelFormId}`, {
    organization_id: orgId,
    model_form: {
      form_items_attributes: {
        id: customField.id,
        model_form_id: modelFormId,
        type: customField.type,
        label: customField.label,
        active: customField.active,
        encrypt: customField.encrypt,
        required: customField.required,
        options_string: customField.options_string,
      },
    },
  });
};

export const deleteCustomField = async (id, orgId) => {
  return destroy(`/api/v1/custom_fields/${id}?organization_id=${orgId}&form_item_id=${id}`);
};
